import styled from 'styled-components';

export const ExpressionView = styled.span``;
